import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getPurchaseOrderInvoiceApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getPurchaseOrderInvoiceListApi = createAsyncThunk('getPurchaseOrderInvoiceList', async (payload) => {
  // console.log('payload', payload);
  return await getPurchaseOrderInvoiceApi(payload);
});

const getPurchaseOrderInvoiceListSlice = createSlice({
  name: 'getPurchaseOrderInvoiceList', // Unique Name
  initialState,
  reducers: {
    getPurchaseOrderInvoiceListReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPurchaseOrderInvoiceListApi.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getPurchaseOrderInvoiceListApi.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getPurchaseOrderInvoiceListApi.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getPurchaseOrderInvoiceListReset } = getPurchaseOrderInvoiceListSlice.actions;

export default getPurchaseOrderInvoiceListSlice.reducer;
